import "./directSales.css"
import React, { useState } from 'react';
import { withFormik, FormikProps, Form, Field } from 'formik';
import { getCityByPincode } from '../../../../../services/area';
import CustomToolTip from '../../../../../Components/CustomToolTip/CustomToolTip';
import { getOtp, individualData, verifyOtpForReg } from '../../../../../services/area';
import showMessage, { failed, showHttpError, success } from '../../../../../utils/message';

interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  contact: string;
  otp: string;
  address1: string;
  address2: string;
  pincode: number;
  city: string;
  bankACno: number;
  ifscCode: string;
  pancard: any;
  aadharcard: any;
  userProfile: any;
}

interface OtherProps {
  message: string;
  className?: string;
  emailClass?: string;
  passClass?: string;
  firstnameClass?: string;
  lastnameClass?: string;
  contactClass?: string;
  otpClass?: string;
  commonInputFieldCss?: string;
  messageClass?: string;
  commonUsedForm?: boolean
}

const InnerForm: any = (props: OtherProps & FormikProps<FormValues>) => {
  const [slideNo, setSlideNo] = useState(0);
  // const [imageOfPan  , setImageOfPan] = useState<any>(null);
  // const [imageOfAadhar  , setImageOfAadhar] = useState<any>(null);
  const [updatedSlideNo, setUpdatedSlideNo] = useState<any>(null);
  // const [cityId , setCityId] = useState("");
  // const [imageOfUserProfile  , setImageOfUserProfile] = useState<any>(null);
  const { touched, errors, message , 
          emailClass , passClass , 
          firstnameClass ,lastnameClass, 
          contactClass , otpClass , 
          commonUsedForm,messageClass,
          commonInputFieldCss, resetForm, initialValues
        } : any = props;

  const checkValues: any = props?.values;

  const fetchCityByPin = async () => {
    try {
      const response = await getCityByPincode(checkValues?.pincode);
      // setCityId(response?._id)
      return [checkValues?.city == response?.name, response?.name]
    } catch (error) {
      showHttpError(error);
    }
  }

  // const verifyIfscCode = async (value:any) => {
  //   try {
  //     const response = await validateIfsc(value);
  //     return response
  //   } catch (error) {
  //     showHttpError(error);
  //   }
  // }

  const isValidEmail = (email: any) => {
    let error;
    if (!email) {
      error = "Required";
    }
    else if (!/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(email)) {
      error = "Invalid email address";
    }
    return error;
  }

  const isValidPassword = (pass: any) => {
    let error;
    if (!pass) {
      error = "Required";
    }
    else if (pass?.length < 6) {
      error = "Min Length 6 Is Required";
    }
    else if (!/^[a-zA-Z0-9]{3,16}$/i.test(pass)) {
      error = "1 AlphaBet & Special Letter Is Required";
    }
    else if (pass?.length > 16) {
      error = "Pass Length Should Not Exceed 16 Letters";
    }
    return error;
  }

  const isValidName = (name: any) => {
    let error;
    if (!name) {
      error = "Required";
    }
    else if (!/^[A-Za-z]*.{3,}$/i.test(name)) {
      error = "Name Should Not Contain Numericals and Min Length Should be 3";
    }
    return error;
  }

  const isValidContact = (contact: any) => {
    let error;
    if (!contact) {
      error = "Required";
    }
    else if (!/^[0-9].{9,9}$/i.test(contact)) {
      error = "Number Should Not be Less Then / Greater Then 10 Nos."
    }
    return error;
  }

  const isValidOtp = (otps: any) => {
    let error;
    if (!otps) {
      error = "Required";
    }
    else if (!/^[0-9].{5,5}$/i.test(otps)) {
      error = "Number Should Not be Less Then / Greater Then 6 Nos."
    }
    return error;
  }

  const isValidPincode = (pincode: any) => {
    let error;
    if (!pincode) {
      error = "Required";
    }
    else if (!/^[0-9].{5,5}$/i.test(pincode)) {
      error = "Pincode Should Not be Less Then / Greater Then 6 Nos."
    }
    return error;
  }

  const isValidAddress = (address: any) => {
    let error;
    if (!address) {
      error = "Required";
    }
    else if (!/^[a-zA-Z3-9\s,'-]*.{3,}$/i.test(address)) {
      error = "Address is not valid format Or Minimum Length Of Address Must be 3"
    }
    return error;
  }

  // const isValidBanAcNo = (accountNo:any) => {
  //     let error;
  //     if(!accountNo){
  //       error = "Required";
  //     }
  //     else if (!/[0-9]{9,18}$/i.test(accountNo)){
  //       error = "Kindly enter valid account number"
  //     }
  //     return error;
  // }

  // const isValidIfscCode = (code:any) => {
  //     let error;
  //     if(!code){
  //       error = "Required";
  //     }
  //     else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/i.test(code)){
  //       error = "Kindly enter valid ifsc code"
  //     }
  //     return error;
  // }

  // const isValidAadharCard = (files:any) => {
  //   let error;
  //   if(!files){
  //     error = "Required";
  //   }
  //   else if (!/[^\s]+(.*?).(jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF)$/i.test(files)){
  //     error = "Kindly Upload Valid Document Format"
  //   }
  //   return error;
  // }

  // const isValidPanCard = (files:any) => {
  //   let error;
  //   if(!files){
  //     error = "Required";
  //   }
  //   else if (!/[^\s]+(.*?).(jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF)$/i.test(files)){
  //     error = "Kindly Upload Valid Document Format"
  //   }
  //   return error;
  // }

  const handleNextBtnClick = async () => {
    if (slideNo === 0 && updatedSlideNo <= 0) {
      if (isValidEmail(checkValues?.email) === undefined &&
        isValidPassword(checkValues?.password) === undefined &&
        isValidName(checkValues?.firstName) === undefined &&
        isValidName(checkValues?.lastName) === undefined &&
        isValidContact(checkValues?.contact) === undefined &&
        isValidOtp(checkValues?.otp) === undefined
      ) {
        {
          let payload = { contact: checkValues?.contact, otp: checkValues?.otp }
          let reasponse: any = await verifyOtpForReg(payload);
          if (reasponse) {
            setSlideNo(slideNo + 1)
            setUpdatedSlideNo(0);
          }
          else {
            showHttpError("Otp MissMatched , Kindly Resend Otp Or Enter Valid Otp")
          }
        }
      }
      else {
        return showMessage("Kindly Fill Up All The Deatils", failed, 2000);
      }
    }

    // if(slideNo === 2 && updatedSlideNo === 1){
    //   if(isValidBanAcNo(checkValues?.bankACno) === undefined && 
    //   isValidIfscCode(checkValues?.ifscCode) === undefined 
    //   ){
    //     // let response = await verifyIfscCode(checkValues?.ifscCode);
    //     // console.log("checkValues?.ifscCode",response)
    //     setSlideNo(slideNo + 1)
    //     setUpdatedSlideNo(2)
    //   }
    //   else{
    //     return showMessage("Kindly Fill Up All The Deatils",failed,2000);
    //   }
    // }
  }

  const RegisterIndividual = async (cityName: any) => {
    try {
      let payload: any = {
        contactPerson: {
          name: {
            fName: checkValues?.firstName,
            lName: checkValues?.lastName
          },
          contact: checkValues?.contact,
          password: checkValues?.password,
          email: checkValues?.email,
        },
        address: {
          l1: checkValues?.address1,
          l2: checkValues?.address2,
          pincode: checkValues?.pincode,
          city: cityName,
        },
        otp: checkValues?.otp,
        individual: true
      }
      // if(imageOfUserProfile){
      //   payload.userProfile = imageOfUserProfile
      // }
      // if(imageOfPan){
      //   payload.panCardImage = imageOfPan
      // }
      await individualData(payload);
      showMessage("Direct Sales Agent Registered Succesfully", success, 2000);
      setSlideNo(0);
      resetForm(initialValues);
    } catch (error) {
      showHttpError(error);
    }
  }

  const handleSubmit = async () => {
    if (slideNo === 1 && updatedSlideNo === 0) {
      if (isValidAddress(checkValues?.address1) === undefined &&
        isValidAddress(checkValues?.address2) === undefined &&
        isValidPincode(checkValues?.pincode) === undefined
      ) {
        let res: any = await fetchCityByPin();
        if (res[0] === true) {
          RegisterIndividual(res[1]);
        }
        else {
          return showHttpError(`Kindly Enter City Name "${res[1]}"`)
        }
      }
      else {
        return showMessage("Kindly Fill Up All The Deatils", failed, 2000);
      }
    }
  }

  return (
    <Form id={"directSalesAgent"}>
      {message && <div className={messageClass}>{message}</div>}
      <div className='dsaTitle'> Direct Sales Agent </div>
      {slideNo === 0 &&
        <div className='formDetailsForDSA'>

          <div className='commonTitleForHeading'>
            <span> General Info </span>
            <span> {slideNo + 1} / 2 </span>
          </div>

          <div className={commonUsedForm ? "commonEmailCss" : emailClass}>
            <Field type="email" name="email" placeholder="Email" className={commonUsedForm ? "commonEmailInputCss" : commonInputFieldCss} validate={isValidEmail} />
            {touched.email && errors.email &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.email && errors?.email} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className={commonUsedForm ? "commonPassCss" : passClass}>
            <Field type="password" name="password" placeholder="Password" className={commonUsedForm ? "commonPassInputCss" : commonInputFieldCss} validate={isValidPassword} />
            {touched.password && errors.password &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.password && errors?.password} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className={commonUsedForm ? "commonFirstNameCss" : firstnameClass}>
            <Field type="text" name="firstName" placeholder="First Name" className={commonUsedForm ? "commonFirstNameInputCss" : commonInputFieldCss} validate={isValidName} />
            {touched.firstName && errors.firstName &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.firstName && errors?.firstName} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className={commonUsedForm ? "commonLastNameCss" : lastnameClass}>
            <Field type="text" name="lastName" placeholder="Last Name" className={commonUsedForm ? "commonLastNameInputCss" : commonInputFieldCss} validate={isValidName} />
            {touched.lastName && errors.lastName &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.lastName && errors?.lastName} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className={commonUsedForm ? "commonContactCss" : contactClass}>
            <Field type="number" name="contact" placeholder="Contact No" className={commonUsedForm ? "commonContactInputCss" : commonInputFieldCss} validate={isValidContact} />
            {touched.contact && errors.contact &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.contact && errors?.contact} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className='commonOtpCss'>
            <button className='commonOtpBtnCss' onClick={async () => {
              console.log("From OTP", props)
              if (touched.contact && errors.contact) {
                showMessage("Kindly Enter Valid Number", failed, 2000)
              }
              if (!errors.email && !errors.password && !errors.firstName && !errors.lastName && !errors.contact) {
                await getOtp(+(props?.values?.contact));
                showMessage("Otp sent SuccesFully !", success, 2000)
              }
            }}>Get Otp</button>
          </div>

          <div className={commonUsedForm ? "commonOTPCss" : otpClass}>
            <Field type="number" name="otp" placeholder="Enter OTP" className={commonUsedForm ? "commonOTPInputCss" : commonInputFieldCss} validate={isValidOtp} />
            {touched.otp && errors.otp &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.otp && errors?.otp} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>
        </div>
      }
      {slideNo === 1 &&
        <div className='formDetailsForDSA'>

          <div className='commonTitleForHeading'>
            <span> Address Details </span>
            <span> {slideNo + 1} / 2 </span>
          </div>

          <div className={commonUsedForm ? "commonEmailCss" : emailClass}>
            <Field type="text" name="address1" placeholder="Enter Address Line 1" className={commonUsedForm ? "commonEmailInputCss" : commonInputFieldCss} validate={isValidAddress} />
            {touched.address1 && errors.address1 &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.address1 && errors?.address1} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className={commonUsedForm ? "commonPassCss" : passClass}>
            <Field type="text" name="address2" placeholder="Enter Address Line 2" className={commonUsedForm ? "commonPassInputCss" : commonInputFieldCss} validate={isValidAddress} />
            {touched.address2 && errors.address2 &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.address2 && errors?.address2} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className={commonUsedForm ? "commonFirstNameCss" : firstnameClass}>
            <Field type="number" name="pincode" placeholder="Pincode" className={commonUsedForm ? "commonFirstNameInputCss" : commonInputFieldCss} validate={isValidPincode} />
            {touched.pincode && errors.pincode &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.pincode && errors?.pincode} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>

          <div className={commonUsedForm ? "commonLastNameCss" : lastnameClass}>
            <Field type="text" name="city" placeholder="City" className={commonUsedForm ? "commonLastNameInputCss" : commonInputFieldCss} />
            {touched.city && errors.city &&
              <div className='commonErrorCss'>
                <CustomToolTip title={errors && errors.city && errors?.city} ><i className='fa fa-info largeScal' /></CustomToolTip>
              </div>
            }
          </div>
        </div>
      }
      {/* {slideNo === 2 &&
          <div className='formDetailsForDSA'>
            <div className={commonUsedForm ? "commonEmailCss" : emailClass}>
                  <Field type="number" name="bankACno" placeholder="Bank Account Number" className={commonUsedForm ? "commonEmailInputCss" : commonInputFieldCss} validate={isValidBanAcNo}/>
                  {touched.bankACno && errors.bankACno && 
                    <div className='commonErrorCss'>
                      <CustomToolTip title={errors && errors.bankACno && errors?.bankACno} ><i className='fa fa-info largeScal' /></CustomToolTip>
                    </div> 
                  }
            </div>

            <div className={commonUsedForm ? "commonPassCss" : passClass}>
                <Field type="text" name="ifscCode" placeholder="Brnach IFSC Code" className={commonUsedForm ? "commonPassInputCss" : commonInputFieldCss} validate={isValidIfscCode}/>
                {touched.ifscCode && errors.ifscCode && 
                  <div className='commonErrorCss'>
                    <CustomToolTip title={errors && errors.ifscCode && errors?.ifscCode} ><i className='fa fa-info largeScal' /></CustomToolTip>
                  </div> 
                }
            </div>
            
          </div> 
        } */}
      {/* {slideNo === 2 &&
          <div className='formDetailsForDSA'>
            
              <div className={commonUsedForm ? "commonImageCss" : emailClass}>
                  PanCard
                  <ImageInput
                    name="Pan Card"
                    Icon={(props: any) => (
                      <i {...props}  className="fas fa-id-card file_icon"></i>
                    )}
                    onChange={(e) => {
                      setImageOfPan(e);
                    }}
                    value={imageOfPan}
                    acceptPdf={true}
                    style={{border:"0.2px solid transparent",height:"50%",marginTop:"2.5%",marginLeft:"2.5%",textAlign:"center"}}
                  />
                    <Field name="pancard" validate={isValidPanCard}>
                      {() => (
                        <div>
                          Pan Card
                          <ImageInput
                            name="Pan Card"
                            Icon={(props: any) => (
                              <i {...props}  className="fas fa-id-card file_icon"></i>
                            )}
                            onChange={(e) => {
                              setImageOfPan(e);
                            }}
                            value={imageOfPan}
                            acceptPdf={true}
                            style={{border:"0.2px solid transparent",height:"50%",marginTop:"2.5%",marginLeft:"2.5%",textAlign:"center"}}
                          />
                          {touched.pancard && errors.pancard && 
                            <div className='commonErrorCss'>
                              <CustomToolTip title={errors && errors.pancard && errors?.pancard} ><i className='fa fa-info largeScal' /></CustomToolTip>
                            </div> 
                          }
                        </div>
                      )}
                    </Field> 
                  {touched.pancard && errors.pancard && 
                    <div className='commonErrorCss'>
                      <CustomToolTip title={errors && errors.pancard && errors?.pancard} ><i className='fa fa-info largeScal' /></CustomToolTip>
                    </div> 
                  }
              </div>

              <div className={commonUsedForm ? "commonImageCss" : passClass}>
                  Aadhar Card
                  <ImageInput
                    name="Aadhar Card"
                    Icon={(props: any) => (
                      <i {...props}  className="fas fa-id-card file_icon"></i>
                    )}
                    onChange={(e) => {
                      setImageOfAadhar(e);
                    }}
                    value={imageOfAadhar}
                    acceptPdf={true}
                    style={{border:"0.2px solid transparent",height:"50%",marginTop:"2.5%",marginLeft:"2.5%",textAlign:"center"}}
                  />
                  {touched.aadharcard && errors.aadharcard && 
                    <div className='commonErrorCss'>
                      <CustomToolTip title={errors && errors.aadharcard && errors?.aadharcard} ><i className='fa fa-info largeScal' /></CustomToolTip>
                    </div> 
                  }
              </div>

              <div className={commonUsedForm ? "commonImageCss" : passClass}>
                  Profile Picture
                  <ImageInput
                    name="User Profile"  
                    Icon={(props: any) => (
                      <i {...props}  className="fas fa-id-card file_icon"></i>
                    )}
                    onChange={(e) => {
                      setImageOfUserProfile(e);
                    }}
                    value={imageOfUserProfile}
                    acceptPdf={true}
                    style={{border:"0.2px solid transparent",height:"50%",marginTop:"2.5%",marginLeft:"2.5%",textAlign:"center"}}
                  />
                  {touched.userProfile && errors.userProfile && 
                    <div className='commonErrorCss'>
                      <CustomToolTip title={errors && errors.userProfile && errors?.userProfile} ><i className='fa fa-info largeScal' /></CustomToolTip>
                    </div> 
                  }
              </div>
          </div> 
        } */}
      <div className='btnsForSlider'>
        {slideNo > 0 && <button className='nextBtnsCSS' onClick={() => { setSlideNo(slideNo - 1), setUpdatedSlideNo(updatedSlideNo - 1) }}> Previous </button>}
        {slideNo <= 0 &&
          <button
            // type='submit' 
            className='prevBtnsCSS'
            onClick={() => handleNextBtnClick()}
          >
            Next
          </button>
        }
        {slideNo > 0 && <button type='submit' className='prevBtnsCSS' onClick={() => handleSubmit()}> Submit </button>}
      </div>
    </Form>
  );
};

interface MyFormProps {
  initialEmail?: string;
  className?: string;
  emailClass?: string;
  passClass?: string;
  firstnameClass?: string;
  lastnameClass?: string;
  contactClass?: string;
  otpClass?: string;
  commonInputFieldCss?: string;
  messageClass?: string;
  commonUsedForm?: boolean;
  message?: string;
  submitFunc?: Function;
}

const DirectSalesAgent = withFormik<MyFormProps, FormValues, OtherProps>({
  mapPropsToValues: (props: any) : any => {
    return {
      firstName: '',
      lastName: '',
      email: props.initialEmail || '',
      password: '',
      contact: '',
      otp: '',
      address1: '',
      address2: '',
      pincode: null,
      city: '',
      bankACno: '',
      ifscCode: '',
      aadharcard: '',
      pancard: '',
      userProfile : ''
    };
  },
  handleSubmit : (values:any) => {
    console.log("Final Submit Ans",values)
  } 
})(InnerForm);

export default DirectSalesAgent;
